<template>
  <div>
    <!-- 履歴 -->
    <el-row>
      <el-col :span="4">
        <p>{{ $locale("membership.memberList.dialog.history.title") }}</p>
      </el-col>
    </el-row>
    <div class="device-group-table">
      <ul class="table-tab clearfix">
        <li v-for="(tab, index) in groupTab" :key="index" :class="index == groupTabIndex ? 'act' : ''"
          @click="getLogForTabs(index)">{{ tab.text }}</li>
      </ul>
      <div class="group-table-box" v-if="!$_.isEmpty(tableObj)">
        <template
          v-for="(item, index) in groupTab"
        >
          <Table
            v-if="groupTabIndex === index"
            :key="index"
            :propsData="tableObj"
            :type="groupTab[groupTabIndex].type"
            :isDetailDisabled="getDetailDisable"
            :memberShipList="injectMemberTypeList"
            @sort="sortHandler"
            @filter="filterHandler"
            @updateStatus="updateStatus"
            @openCoupon="isCouponPaymentOpen = true"
            @openAdjustPoint="isAdjustPointOpen = true"
          />
        </template>
       <CommPagination
        v-if="filter[groupTab[groupTabIndex].type]"
        :total="filter[groupTab[groupTabIndex].type].count"
        :curPage="filter[groupTab[groupTabIndex].type].curPage"
        @current-change="pageChange"
        :pageSize="20"
        style="height: 34px;margin-right: 0;"
      />
      </div>
    </div>
    <!-- Dialog -->
    <UpdateDialog title="優待券付与" :isOpen.sync="isCouponPaymentOpen">
      <DialogItem ref="couponDialog" :propForm="couponPaymentObj" :targetList="injectCouponOptionList" listTitle="付与する優待券を選択してください"
        targetKey="couponId" @save="sendCoupon_fn" @close="closeCoupon_fn" />
    </UpdateDialog>
    <UpdateDialog title="ポイント数調整" :isOpen.sync="isAdjustPointOpen">
      <DialogItem :propForm="adjustPointObj" listTitle="ポイント数調整"
        @save="adjustPoint_fn" :isHidePicker="true" :isHideAdjust="false" @close="closePoint_fn" />
    </UpdateDialog>
  </div>
</template>
<script>
import { getGroupTab, getHistoryTableObj, getMemberCouponStatus, getUsePlace } from "@/assets/js/membership";
import UpdateDialog from "@/components/MemberShip/MemberList/updateDialog.vue";
import {
  getMemberCouponLogService, sendCouponService, updateMemberCouponStatusService,
  getCouponUseLogService, getPointLogService, adjustPointService, getRankLogService, getMemberShipChangeLogService, getRankOptionService,
  getTicketHistoryService, getProductHistroyService,
} from "@/helpers/service/api/membership";
import { getSimpleMovieList } from "@/helpers/service/api/common";
import { salesStatus } from "@/utils/common.js";
import { taxRatesMap } from "@/utils/common";
import DialogItem from "@/components/MemberShip/MemberList/DialogItem.vue";
import countDownAlert from "@/utils/countDownAlert";
import CommPagination from "@/components/common/CommPagination";
import Table from "@/components/MemberShip/MemberList/Table.vue";
export default {
  inject: ["isDeatilDisable", "cinemaList", "couponOptionList", "memberTypeList", "rankTypeList"],
  data() {
    return {
      rankList: [],
      filmList: [],
      tableObj: {},
      groupTab: getGroupTab(),
      groupTabIndex: 0,
      isCouponPaymentOpen: false,
      isAdjustPointOpen: false,
      apiCalled: {
        ticket: false,
        shop: false,
        coupon: false,
        couponUse: false,
        point: false,
        rank: false,
        memberShipChange: false
      },
      filter: {
        ticket: {
          sortType: "",
          sortKey: "",
          count: 0,
          curPage: 0,
        },
        shop: {
          sortType: "",
          sortKey: "",
          count: 0,
          curPage: 0,
        },
        coupon: {
          sortType: "",
          sortKey: "",
          count: 0,
          curPage: 0,
          cinemaId: [],
          memberCouponStatus: [],
        },
        couponUse: {
          sortType: "",
          sortKey: "",
          useType: [],
          placeType: [],
          cinemaId: [],
          count: 0,
          curPage: 0,
        },
        point: {
          sortType: "",
          sortKey: "",
          count: 0,
          curPage: 0,
        },
        rank: {
          sortType: "",
          sortKey: "",
          membershipRankId: [],
          count: 0,
          curPage: 0,
        },
        memberShipChange: {
          cinemaId: [],
          memberShipId: [],
          sortType: "",
          sortKey: "",
          count: 0,
          curPage: 0,
        }
      },
      couponPaymentObj: {
        userId: this.id,
        couponId: "",
        expireTimeLimit: true,
        expireTime: null,
        remark: "",
      },
      adjustPointObj: {
        userId: this.id,
        point: "",
        remark: "",
      },
      getMemberCouponStatus,
      getUsePlace,
    };
  },
  async mounted() {
    await getSimpleMovieList({
      // brandId: window.localStorage.getItem("brandId"),
      approve: true,
      page: 0,
      pageSize: 99999,
      cinemaId: this.cinemaId,
      field: ["id", "name"],
      // hiddenCms: false,
    }).then(res => {
      if (res.data && res.data.data.length > 0) {
        this.filmList = res.data.data;
      }
    });
    await getRankOptionService({ userId: this.id }).then(res => {
      if (res.data && res.data.length > 0) {
        this.rankList = res.data;
      }
      this.tableObj = getHistoryTableObj(
          this.injectCinemaList,
          this.injectCouponOptionList,
          this.injectMemberTypeList,
          res.data,
          this.filmList,
          salesStatus,
          taxRatesMap,
        );
        this.getTransactionHistory();
        // this.getMemberCouponLog();
        // this.getCouponUseLog();
        // this.getPointLog();
        // this.getRankLog();
        // this.getMemberShipLog();
        // this.getShopTransactionHistory();
        // this.getConcessionHistory();
        // this.getConmercialHistory();
    });
  },
  computed: {
    historyType() {
      return this.groupTab[this.groupTabIndex].type;
    },
    getDetailDisable() {
      return this.isDeatilDisable();
    },
    injectCinemaList() {
      return this.cinemaList();
    },
    injectCouponOptionList() {
      return this.couponOptionList();
    },
    injectMemberTypeList() {
      return this.memberTypeList();
    },
    injectRankTypeList() {
      return this.rankTypeList();
    },
  },
  methods: {
    getLogForTabs(index) {
      this.$forceUpdate();
      this.groupTabIndex = index;
      const apiMappings = {
        ticket: this.getTransactionHistory,
        shop: this.getShopTransactionHistory,
        coupon: this.getMemberCouponLog,
        couponUse: this.getCouponUseLog,
        point: this.getPointLog,
        rank: this.getRankLog,
        memberShipChange: this.getMemberShipLog,
      };
      const dataMappings = {
        ticket: this.tableObj.ticket.tableData,
        shop: this.tableObj.shop.tableData,
        coupon: this.tableObj.coupon.tableData,
        couponUse: this.tableObj.couponUse.tableData,
        point: this.tableObj.point.tableData,
        rank: this.tableObj.rank.tableData,
        memberShipChange: this.tableObj.memberShipChange.tableData,
      };
      const curType = this.groupTab[this.groupTabIndex].type;
      
      if (!this.apiCalled[curType] && dataMappings[curType].length === 0) {
        apiMappings[curType]();
        this.apiCalled[curType] = true;
      }
    },
    // temp
    getTransactionHistory() {
      getTicketHistoryService({
        userId: this.id,
				...this.filter.ticket.sortKey ? { sortKey: this.filter.ticket.sortKey } : {},
        ...this.filter.ticket.sortType ? { sortType: this.filter.ticket.sortType } : {},
        page: this.filter.ticket.curPage,
        pageSize: 20
      }).then(res => {
        this.filter.ticket.count = res.count;
        if (res.data && res.data.length > 0) {
          this.filter.ticket.count = res.count;
          this.tableObj.ticket.tableData = res.data;
        } else {
          this.tableObj.ticket.tableData = []
        }
        // 标记API已被调用
        this.apiCalled.ticket = true;
      })
    },
    getShopTransactionHistory() {
      getProductHistroyService({
        userId: this.id,
        ...this.filter.shop.sortKey ? { sortKey: this.filter.shop.sortKey } : {},
        ...this.filter.shop.sortType ? { sortType: this.filter.shop.sortType } : {},
        page: this.filter.shop.curPage,
        pageSize: 20
      }).then(res => {
        this.filter.shop.count = res.count;
        if (res.data && res.data.length > 0) {
          this.tableObj.shop.tableData = res.data;
          this.filter.shop.count = res.count;
        } else {
          this.tableObj.shop.tableData = []
        }
        // 标记API已被调用
        this.apiCalled.shop = true;
      })
    },
    renderCoupon(h, { column }) {
      return h("a", {
        style: { color: "#F9B749", letterSpacing: "0.72px" },
        on: { click: () => { this.isCouponPaymentOpen = true; } }
      }, column.label);
    },
    async getMemberCouponLog() {
      await getMemberCouponLogService({
        userId: this.id,
        ...this.filter.coupon.sortKey ? { sortKey: this.filter.coupon.sortKey } : {},
        ...this.filter.coupon.sortType ? { sortType: this.filter.coupon.sortType } : {},
        ...this.filter.coupon.cinemaId.length > 0 ? { cinemaId: this.filter.coupon.cinemaId } : {},
        ...this.filter.coupon.memberCouponStatus.length > 0 ? { memberCouponStatus: this.filter.coupon.memberCouponStatus } : {},
        page: this.filter.coupon.curPage,
        pageSize: 20,
      }).then(res => {
        this.filter.coupon.count = res.data.count;
        if (res.data && res.data.data.length > 0) {
          this.tableObj.coupon.tableData = res.data.data;
          this.filter.coupon.count = res.data.count;
        } else {
          this.tableObj.coupon.tableData = [];
        }
        // 标记API已被调用
        this.apiCalled.coupon = true;
      });
    },
    async getCouponUseLog() {
      await getCouponUseLogService({
        userId: this.id,
        ...this.filter.couponUse.sortKey ? { sortKey: this.filter.couponUse.sortKey } : {},
        ...this.filter.couponUse.sortType ? { sortType: this.filter.couponUse.sortType } : {},
        ...this.filter.couponUse.useType.length > 0 ? { useType: this.filter.couponUse.useType } : {},
        ...this.filter.couponUse.placeType.length > 0 ? { placeType: this.filter.couponUse.placeType } : {},
        ...this.filter.couponUse.cinemaId.length > 0 ? { cinemaId: this.filter.couponUse.cinemaId } : {},
        page: this.filter.couponUse.curPage,
        pageSize: 20,
      }).then(res => {
        this.filter.couponUse.count = res.data.count;
        if (res.data && res.data.data.length > 0) {
          this.tableObj.couponUse.tableData = res.data.data;
          this.filter.couponUse.count = res.data.count;
        } else {
          this.tableObj.couponUse.tableData = [];
        }
        // 标记API已被调用
        this.apiCalled.couponUse = true;
      });
    },
    async getPointLog() {
      await getPointLogService({
        userId: this.id,
        ...this.filter.point.sortKey ? { sortKey: this.filter.point.sortKey } : {},
        ...this.filter.point.sortType ? { sortType: this.filter.point.sortType } : {},
        page: this.filter.point.curPage,
        pageSize: 20,
      }).then(res => {
        this.filter.point.count = res.data.count;
        if (res.data && res.data.data.length > 0) {
          this.tableObj.point.tableData = res.data.data;
          this.filter.point.count = res.data.count;
        } else {
          this.tableObj.point.tableData = [];
        }
        // 标记API已被调用
        this.apiCalled.point = true;
      });
    },
    async getRankLog() {
      await getRankLogService({
        userId: this.id,
        ...this.filter.rank.sortKey ? { sortKey: this.filter.rank.sortKey } : {},
        ...this.filter.rank.sortType ? { sortType: this.filter.rank.sortType } : {},
        ...this.filter.rank.membershipRankId.length > 0 ? { membershipRankId: this.filter.rank.membershipRankId } : {},
        page: this.filter.rank.curPage,
        pageSize: 20,
      }).then(res => {
        this.filter.rank.count = res.data.count;
        if (res.data && res.data.data.length > 0) {
          this.tableObj.rank.tableData = res.data.data;
          this.filter.rank.count = res.data.count;
        } else {
          this.tableObj.rank.tableData = [];
        }
        // 标记API已被调用
        this.apiCalled.rank = true;
      });
    },
    async getMemberShipLog() {
      await getMemberShipChangeLogService({
        userId: this.id,
        ...this.filter.memberShipChange.sortKey ? { sortKey: this.filter.memberShipChange.sortKey } : {},
        ...this.filter.memberShipChange.sortType ? { sortType: this.filter.memberShipChange.sortType } : {},
        ...this.filter.memberShipChange.cinemaId.length > 0 ? { cinemaId: this.filter.memberShipChange.cinemaId } : {},
        ...this.filter.memberShipChange.memberShipId.length > 0 ? { membershipId: this.filter.memberShipChange.memberShipId } : {},
        page: this.filter.memberShipChange.curPage,
        pageSize: 20,
      }).then(res => {
        this.filter.memberShipChange.count = res.data.count;
        if (res.data && res.data.data.length > 0) {
          this.tableObj.memberShipChange.tableData = res.data.data;
          this.filter.memberShipChange.count = res.data.count;
        } else {
          this.tableObj.memberShipChange.tableData = [];
        }
        // 标记API已被调用
        this.apiCalled.memberShipChange = true;
      });
    },
    sendCoupon_fn() {
      sendCouponService({
        couponId: this.couponPaymentObj.couponId,
        ...this.couponPaymentObj.expireTimeLimit && this.couponPaymentObj.expireTime ? { expireTime: this.couponPaymentObj.expireTime } : {},
        remark: this.couponPaymentObj.remark,
        userId: this.couponPaymentObj.userId,
      }).then(res => {
        if (res.success) {
          countDownAlert({
            content: this.$locale("global.operationSuccessful"), callback: () => {
              this.$emit("refreshCoupon");
              this.$emit("refreshCouponUse");
              this.isCouponPaymentOpen = false;
            }
          });
        }
      });
    },
    updateStatus(id, type) {
      updateMemberCouponStatusService({
        couponId: id,
        status: type
      }).then(res => {
        if (res.success) {
          countDownAlert({
            content: this.$locale("global.operationSuccessful"), callback: () => {
              // this.getList()
              this.getLogListForType();
            }
          });
        }
      });
    },
    getLogListForType() {
      const { type } = this.groupTab[this.groupTabIndex];
      switch (type) {
        case "ticket":
          this.getTransactionHistory();
          break;
          case "shop":
          this.getShopTransactionHistory();
          break;
      case "coupon":
        this.getMemberCouponLog();
        break;
      case "couponUse":
        this.getCouponUseLog();
        break;
      case "point":
        this.getPointLog();
        break;
      case "rank":
        this.getRankLog();
        break;
      case "memberShipChange":
        this.getMemberShipLog();
        break;
      default:
        break;
      }
    },
    sortHandler(sort) {
      const { type } = this.groupTab[this.groupTabIndex];
      this.filter[type] = {
        ...this.filter[type],
        sortType: !sort.order ? "" : (sort.order === "ascending" ? "ASC" : "DESC"),
        sortKey: sort.order ? sort.prop : ""
      };
      this.getLogListForType();
    },
    filterHandler(filters) {
      const { type } = this.groupTab[this.groupTabIndex];
      const [ key ] = Object.keys(filters);
      this.filter[type][key] = filters[key];

      this.getLogListForType();
    },
    pageChange(value) {
      if (!value) { return; }
      const { type } = this.groupTab[this.groupTabIndex];
      this.filter[type].curPage = value - 1;
      this.getLogListForType();
    },
    adjustPoint_fn() {
      adjustPointService(this.adjustPointObj).then(res => {
        if (res.success) {
          countDownAlert({
            content: this.$locale("global.operationSuccessful"), callback: () => {
              this.getPointLog();
              this.isAdjustPointOpen = false;
            }
          });
        }
      });
    },
    closeCoupon_fn() {
      this.couponPaymentObj = {
        userId: this.id,
        couponId: "",
        expireTimeLimit: true,
        expireTime: null,
        remark: "",
      };
      this.$nextTick(() => {
        if (this.$refs.couponDialog) {
          this.$refs.couponDialog.$refs.detailForm.clearValidate();
        }
      })
      this.isCouponPaymentOpen = false;
    },
    closePoint_fn() {
      this.isAdjustPointOpen = false;
      this.adjustPointObj = {
        userId: this.id,
        point: "",
        remark: "",
      };
    },
    // 添加重置API调用状态的方法
    resetApiCalledStatus() {
      // 重置所有API调用状态
      this.apiCalled = {
        ticket: false,
        shop: false,
        coupon: false,
        couponUse: false,
        point: false,
        rank: false,
        memberShipChange: false
      };
      // 重置当前选中的标签页索引
      this.groupTabIndex = 0;
    },
    // 添加清空所有表格数据的方法
    clearAllData() {
      // 清空所有表格数据
      Object.keys(this.tableObj).forEach(key => {
        if (this.tableObj[key] && this.tableObj[key].tableData) {
          this.tableObj[key].tableData = [];
        }
      });
      
      // 重置过滤和分页状态
      Object.keys(this.filter).forEach(key => {
        if (this.filter[key]) {
          this.filter[key].count = 0;
          this.filter[key].curPage = 0;
        }
      });
    },
  },
  props: {
    id: {
      type: String,
      default: () => ""
    },
    isDialogOpen: {
      type: Boolean,
      default: false
    }
  },
  components: {
    UpdateDialog,
    DialogItem,
    CommPagination,
    Table
  },
  watch: {
    isDialogOpen(val) {
      if (val) {
        // 弹窗打开时，设置用户ID
        this.couponPaymentObj.userId = this.id;
        this.adjustPointObj.userId = this.id;
        
        // 重置API调用状态，以便重新请求数据
        this.resetApiCalledStatus();
        
        // 只请求当前标签的数据
        const curType = this.groupTab[this.groupTabIndex].type;
        const apiMappings = {
          ticket: this.getTransactionHistory,
          shop: this.getShopTransactionHistory,
          coupon: this.getMemberCouponLog,
          couponUse: this.getCouponUseLog,
          point: this.getPointLog,
          rank: this.getRankLog,
          memberShipChange: this.getMemberShipLog,
        };
        
        // 调用对应的API
        apiMappings[curType]();
      } else {
        // 弹窗关闭时，清空所有数据
        this.clearAllData();
      }
    }
  }
};
</script>
<style lang="less" scoped>
.device-group-table {
  border: 1px solid #ebeef5;

  .group-table-box {
    border-top: 1px solid #ebeef5;
    padding: 0 15px 20px 15px;
  }

  .table-tab {
    background: @input-inner-color;
    color: @other-grey;
    margin: auto auto -1px auto;
    padding: 0;

    li {
      box-sizing: border-box;
      cursor: pointer;
      float: left;
      font-size: 16px;
      line-height: 32px;
      padding: 9px 17px 9px 16px;

      &.act {
        background: @pure-white;
        border-left: 1px solid #ebeef5;
        border-right: 1px solid #ebeef5;
        border-bottom: 1px solid @pure-white;
        color: @primary-black;
        cursor: auto;
        padding: 9px 50px 9px 41px;
        position: relative;

        &:first-child {
          border-left: 0;
        }

        &:before {
          background: @primary-orange;
          border-radius: 2px;
          content: "";
          display: block;
          height: 3px;
          position: absolute;
          right: 33px;
          bottom: 9px;
          left: 25px;
        }
      }
    }
  }

  thead {
    th {
      background: @pure-white;
      border-bottom: 1px solid #ebeef5;
      font-weight: normal;
    }
  }
}
</style>